/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Tier_BenefitInputs */

const en_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Tier Benefit`)
};

const es_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beneficio del nivel Sovereign`)
};

const fr_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avantage du niveau Sovereign`)
};

const de_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorteil der Sovereign-Stufe`)
};

const ja_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign ティア特典`)
};

const zh_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 级别权益`)
};

const ar_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميزة مستوى Sovereign`)
};

const id_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manfaat Paket Sovereign`)
};

const it_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vantaggio del Livello Sovereign`)
};

const ru_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преимущество тарифа Sovereign`)
};

const pt_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefício do Plano Sovereign`)
};

const ko_sovereign_tier_benefit = /** @type {(inputs: Sovereign_Tier_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 등급 혜택`)
};

/**
* | output |
* | --- |
* | "Sovereign Tier Benefit" |
*
* @param {Sovereign_Tier_BenefitInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_tier_benefit = /** @type {((inputs?: Sovereign_Tier_BenefitInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Tier_BenefitInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_tier_benefit(inputs)
	if (locale === "es") return es_sovereign_tier_benefit(inputs)
	if (locale === "fr") return fr_sovereign_tier_benefit(inputs)
	if (locale === "de") return de_sovereign_tier_benefit(inputs)
	if (locale === "ja") return ja_sovereign_tier_benefit(inputs)
	if (locale === "zh") return zh_sovereign_tier_benefit(inputs)
	if (locale === "ar") return ar_sovereign_tier_benefit(inputs)
	if (locale === "id") return id_sovereign_tier_benefit(inputs)
	if (locale === "it") return it_sovereign_tier_benefit(inputs)
	if (locale === "ru") return ru_sovereign_tier_benefit(inputs)
	if (locale === "pt") return pt_sovereign_tier_benefit(inputs)
	return ko_sovereign_tier_benefit(inputs)
});